module.exports = __webpack_public_path__ + "img/SDG-07-EN.1965a897.png";